import { Component, Input, ChangeDetectionStrategy, OnInit } from '@angular/core';
import { InputType } from '../input/input-type.enum';
import { UtilService } from '../../../service/util.service';
import { FieldBase } from '../field-base.class';

@Component({
  selector: 'cs-customer-num',
  templateUrl: './customer-num.component.html',
  styleUrls: ['./customer-num.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CustomerNumComponent extends FieldBase implements OnInit{

  /** By default, type is InputType.TEXT. */
  @Input() type: InputType = InputType.TEXT;
 
  /** By default, maxlength is undefined and the input length is not limited. */
  @Input() maxlength: number = undefined;

  /** By default, disabled is undefined and the input is not disabled. */
  @Input() disabled: boolean;

  /** Default class of the input group container */
  @Input() inputGroupClass: string = "input-group";

  @Input() autocomplete: string = "on";

  @Input() cursorNotAllowed: boolean;

  constructor(private utilService: UtilService) { 
    super();
  }

  ngOnInit(): void {
    this.inputClass = this.setDefaultInputClass();
  }

  /** By default, inputClass is form-control. */
  setDefaultInputClass(): string {
    if (this.cursorNotAllowed === true) {
      return "form-control cursor-not-allowed";
    } else {
      return "form-control";
    }
  }

  onKeyPress(keyCode: number): boolean {
    switch (this.type) {
      case InputType.INTEGER:
        return this.onKeyPressInteger(keyCode);
      case InputType.DECIMAL:
        return this.onKeyPressDecimal(keyCode);
      default:
        return true;
    }
  }

  /** Only numbers are allowed. */
  private onKeyPressInteger(keyCode: number): boolean {
    if (keyCode < 48 || keyCode > 57) {
      return false;
    } else {
      return true;
    }
  }

  /** Only numbers and dots are allowed. */
  private onKeyPressDecimal(keyCode: number): boolean {
    if (keyCode !== 46 && (keyCode < 48 || keyCode > 57)) {
      return false;
    } else {
      return true;
    }
  }

  onPaste($event: ClipboardEvent) {
    switch (this.type) {
      case InputType.INTEGER:
        return this.onPasteInteger($event);
      case InputType.DECIMAL:
        return this.onPasteDecimal($event);
      default:
        break;
    }
  }

  /** Only numbers are allowed. */
  private onPasteInteger($event: ClipboardEvent) {
    let clipboardData = $event.clipboardData.getData("text/plain");
    if (!this.utilService.isInteger(clipboardData)) {
      $event.preventDefault();
    } 
  }

  /** Only numbers and dots are allowed. */
  private onPasteDecimal($event: ClipboardEvent) {
    let clipboardData = $event.clipboardData.getData("text/plain");
    if (!this.utilService.isDecimal(clipboardData)) {
      $event.preventDefault();
    } 
  }

  onKeyDown(event: KeyboardEvent) { }

  onFocusOut() { }

}
